import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Trafikkvekst: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon'>
				<path
					id='Vector'
					d='M9.77683 4.22097C9.77683 3.85147 10.0741 3.5542 10.4436 3.5542H15.3332C15.7027 3.5542 16 3.85147 16 4.22097V9.1106C16 9.4801 15.7027 9.77737 15.3332 9.77737C14.9637 9.77737 14.6665 9.4801 14.6665 9.1106V5.82954L9.3601 11.1387C9.09895 11.3998 8.67667 11.3998 8.41829 11.1387L5.33449 8.05488L1.13663 12.25C0.875482 12.5111 0.453195 12.5111 0.194823 12.25C-0.0635499 11.9888 -0.0663281 11.5665 0.194823 11.3082L4.85942 6.638C5.12057 6.37685 5.54286 6.37685 5.80123 6.638L8.88503 9.7218L13.7247 4.88774H10.4436C10.0741 4.88774 9.77683 4.59047 9.77683 4.22097Z'
					fill={pathFill}
				/>
			</g>
		</svg>
	);
};
